module.exports = require("yeoman-generator/lib");